import styled from 'styled-components';
import { Button, Typography, Divider, Card } from 'antd';


export const DangerousLink = styled(Button)`
	color: red!important;
`;

export const FullWidthDivider = styled(Divider)`
	margin: 0px!important;
`;

// Semantic Texts
export const Text1 = styled(Typography.Text)`
	font-size: 20px!important;
`;

export const Text2 = styled(Typography.Text)`
	font-size: 18px!important;
`;

export const Text3 = styled(Typography.Text)`
	font-size: 16px!important;
`;

export const Text4 = styled(Typography.Text)`
	font-size: 14px!important;
`;

export const Text5 = styled(Typography.Text)`
	font-size: 12px!important;
`;

export const RoundedCard = styled(Card)`
	border-radius: 10px!important;
	box-shadow: 2px 2px 5px 0px #ddd!important;
`;